import { render, staticRenderFns } from "./TopRank.vue?vue&type=template&id=6f3a2074&scoped=true&"
import script from "./TopRank.vue?vue&type=script&lang=js&"
export * from "./TopRank.vue?vue&type=script&lang=js&"
import style0 from "./TopRank.vue?vue&type=style&index=0&id=6f3a2074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a2074",
  null
  
)

export default component.exports